export default __webpack_public_path__ + "static/porque-dimas-bbce148e3437fa61c73984722f585512.jpg";